import { render, staticRenderFns } from "./FormTagInput.vue?vue&type=template&id=d0f234d4&"
import script from "./FormTagInput.vue?vue&type=script&lang=js&"
export * from "./FormTagInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports